// Copyright 2021-2022 zcloak authors & contributors
// SPDX-License-Identifier: Apache-2.0

import { Box } from '@mui/material';
import React, { useMemo } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import Footer from './Footer';
import Header from './Header';

const BaseContainer: React.FC = () => {
  const location = useLocation();

  const isChampion = useMemo(
    () => location.pathname === '/verify/champion' || location.pathname === '/prize',
    [location]
  );

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        background: `${
          isChampion
            ? 'url(png_win_1x.webp) no-repeat, url(png_playfootball.webp) no-repeat, url(png_winner_1x.webp) no-repeat'
            : 'url(png_football.webp) no-repeat, url(png_playfootball.webp) no-repeat'
        }`,
        backgroundPosition: `${
          isChampion
            ? '10px 55%, right bottom 160px, top right 30%'
            : '-120px 50%, right bottom 160px'
        }`
      }}
    >
      <Header />
      <Box flex="1">
        <Outlet />
      </Box>
      <Box justifySelf="flex-end">
        <Footer />
      </Box>
    </Box>
  );
};

export default BaseContainer;
